export default {
	events: {
		'ddc.inventory.filterSearch.click': {
			payload: {
				experimental: {
					eventId: '[[eventData.eventId]]'
				},
				label: 'searchFacet | [[eventData.clickedFacetName]]',
				shared: [
					'[[mapping.configuration.sharedPayloads.vehicleSearchCommon]]',
					'[[mapping.configuration.sharedPayloads.commonFacets]]'
				],
				vehicles: '[[fn.getVehicleArray()]]'
			}
		},
		'ddc.inventory.filterSearch': {
			logic: {},
			payload: {
				experimental: {
					eventId: '[[eventData.eventId]]'
				},
				type: 'event',
				eventType: 'ajaxPageView',
				pageType: 'vlp',
				pageId: '[[pageId]]',
				label: '[[pageAlias]]',
				shared: [
					'[[mapping.configuration.sharedPayloads.commonFacets]]'
				]
			},
			fireGroup: 'ajaxPageGroup'
		},
		'ddc.form.change': {
			logic: {
				linkType: 'select-one',
				widgetName: 'ws-inv-listing'
			},
			payload: {
				experimental: {
					eventId: '[[eventData.eventId]]'
				},
				label: 'searchSort | [[eventData.label]]',
				shared: [
					'[[mapping.configuration.sharedPayloads.vehicleSearchCommon]]',
					'[[mapping.configuration.sharedPayloads.commonFacets]]'
				]
			}
		},
		'ddc.form.confirmation': [
			{
				// This particular case is fueled by DDC.pushEvent due to an edge case working with Angular code with AutoNation
				// LINK: https://ghe.coxautoinc.com/DDC-WebPlatform/cms-web/blob/master/htdocs/v9/widgets/specials/autonation/v1/js/widget.js
				logic: {
					widgetName: 'specials-autonation'
				},
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					type: 'event',
					eventSource: 'incentive',
					eventType: 'sign-up',
					pageId: '[[DDC.dataLayer.page.pageInfo.pageId]]'
				}
			},
			{
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					type: 'event',
					eventType: 'formSubmission',
					formType: '[[fn.getFormTrackingName]]',
					formEventId: '[[eventData.formEventId]]',
					vin: '[[eventData.vehicle.vin]]',
					stockNumber: '[[eventData.vehicle.stockNumber]]',
					exteriorColor: '[[eventData.vehicle.exteriorColor]]',
					vehicleId: '[[eventData.vehicle.uuid]]',
					vehicleType: '[[eventData.vehicle.inventoryType]]',
					listingCode: '[[eventData.vehicle.accountId]]'
				}
			}
		],
		'ddc.inventory.typedSearch': {
			payload: {
				experimental: {
					eventId: '[[eventData.eventId]]'
				},
				type: 'event',
				eventType: 'view',
				eventSource: 'vehicle',
				label: 'searchText | [[eventData.queryFacets.search]]',
				shared: [
					'[[mapping.configuration.sharedPayloads.commonFacets]]'
				]
			}
		},
		'ddc.link.sendToPhone': {
			payload: {
				experimental: {
					eventId: '[[eventData.eventId]]'
				},
				type: 'event',
				eventType: 'click',
				eventSource: 'incentive',
				label: 'send offer to phone'
			}
		},
		widgetUserEvent: [
			{
				logic: {
					widgetName: 'ws-vehicle-media',
					result: 'Opens gallery modal'
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					eventType: 'image_view',
					shared: [
						'[[mapping.configuration.sharedPayloads.VDPVehicle]]',
						'[[mapping.configuration.sharedPayloads.slideshowCommmon]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-vehicle-media',
					result: 'Move to next photo'
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					eventType: 'carousel_scroll',
					shared: [
						'[[mapping.configuration.sharedPayloads.VDPVehicle]]',
						'[[mapping.configuration.sharedPayloads.slideshowCommmon]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-vehicle-media',
					result: 'Move to previous photo'
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					eventType: 'carousel_scroll',
					shared: [
						'[[mapping.configuration.sharedPayloads.VDPVehicle]]',
						'[[mapping.configuration.sharedPayloads.slideshowCommmon]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-detailed-specs',
					mustNotInclude: {
						'eventData.result': 'expanded',
						'eventData.elementCTA': 'Detailed Specifications'
					}
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					type: 'event',
					eventType: 'click',
					eventSource: 'vehicle',
					label: 'accordion | Opened [[eventData.elementCTA]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.VDPVehicle]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-detailed-specs',
					mustNotInclude: {
						'eventData.result': 'collapsed',
						'eventData.element': 'Detailed Specifications'
					}
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					type: 'event',
					eventType: 'click',
					eventSource: 'vehicle',
					label: 'accordion | Closed [[eventData.elementCTA]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.VDPVehicle]]'
					]
				}
			},
			{
				logic: {
					widgetName: 'ws-rec-vehicles',
					result: 'Recommended vehicles impression'
				},
				payload: '[[fn.getWsRecVehiclesWidgetImpressionPayloads()]]'
			},
			{
				logic: {
					widgetName: 'ws-rec-vehicles',
					result: 'Navigated to VDP'
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					shared: [
						{
							type: 'event',
							eventSource: 'vehicle',
							eventType: 'click',
							feature: 'recommended_vehicles',
							listingType: '',
							year: '[[eventData.year]]',
							make: '[[eventData.make]]',
							model: '[[eventData.model]]',
							bodyStyle: '[[eventData.bodyStyle]]',
							stockNumber: '[[eventData.stockNumber]]',
							vin: '[[eventData.vin]]',
							odometer: '[[eventData.odometer]]',
							fuelEconomy:
								'[[eventData.cityFuelEconomy]] mpg city, [[eventData.highwayFuelEconomy]] mpg hwy'
						},
						{
							logic: {
								mustInclude: {
									'eventData.element': 'CVRE'
								}
							},
							payload: {
								feature: 'experience_optimization',
								listingType: 'recommendation'
							}
						}
					]
				}
			},
			{
				logic: [
					{
						widgetName: 'ws-inv-listing',
						result: 'Vehicle saved'
					},
					{
						widgetName: 'ws-mycars-vdp',
						result: 'Vehicle saved'
					}
				],
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					type: 'event',
					eventSource: 'vehicle',
					eventType: 'save',
					feature: 'mycars',
					hitType: 'my-cars-event',
					shared: [
						'[[mapping.configuration.sharedPayloads.myCarsVehicle]]'
					]
				}
			},
			{
				logic: [
					{
						widgetName: 'ws-inv-listing',
						result: 'Email Signup for Price Alert Notifications'
					},
					{
						widgetName: 'ws-mycars-vdp',
						result: 'Email Signup for Price Alert Notifications'
					}
				],
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					type: 'event',
					eventSource: 'vehicle',
					eventType: 'watch',
					feature: 'mycars',
					hitType: 'my-cars-event',
					consumerMetadata: {
						email: '[[eventData.emailAddress]]'
					},
					shared: [
						'[[mapping.configuration.sharedPayloads.myCarsVehicle]]'
					]
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: {
					widgetName: 'specials-autonation'
				},
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					type: 'event',
					eventSource: 'incentive',
					eventType: 'click',
					pageId: '[[DDC.dataLayer.page.pageInfo.pageId]]',
					label: '[[eventData.text]] >> [[eventData.attributes.innerText]]'
				}
			},
			{
				logic: {
					isTelephonicUrl: true
				},
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					type: 'event',
					eventSource: 'lead',
					eventType: 'click',
					pageId: '[[DDC.dataLayer.page.pageInfo.pageId]]'
				}
			},
			{
				logic: ({ eventData: { text, url } = {} } = {}) =>
					`${text}${url}`?.toLowerCase()?.includes('service') &&
					url !== '#',
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					eventSource: 'service',
					eventType: 'click',
					label: '[[eventData.text]]',
					type: 'event'
				}
			}
		],
		thirdPartyUserEvent: [
			{
				logic: {
					product: 'activengage-api',
					action: 'clicked',
					result: 'success'
				},
				payload: {
					experimental: {
						eventId: '[[DDC.dataLayer.page.pageViewId]]'
					},
					shared: [
						'[[mapping.configuration.sharedPayloads.chatOpened]]'
					]
				}
			}
		],
		'vehicle-shown': [
			{
				logic: [
					{
						mustInclude: {
							'DDC.dataLayer.page.pageInfo.pageWidgets':
								'ws-inv-listing',
							'DDC.dataLayer.page.pageInfo.params':
								'_toggleDelayLoadSRP=true'
						},
						mustNotInclude: {
							'DDC.dataLayer.page.pageInfo.params':
								'_disablePixall=true'
						}
					},
					{
						mustInclude: {
							'DDC.dataLayer.page.pageInfo.pageWidgets':
								'v9.widgets.inventory-listing.default.v2'
						},
						mustNotInclude: {
							'DDC.dataLayer.page.pageInfo.params':
								'_disablePixall=true'
						}
					},
					{
						mustInclude: {
							'DDC.dataLayer.page.pageInfo.isVlp': true
						},
						mustNotInclude: {
							'DDC.dataLayer.page.pageInfo.params':
								'_disablePixall=true',
							'DDC.dataLayer.page.pageInfo.pageWidgets': [
								'ws-inv-listing',
								'v9.widgets.inventory-listing.default.v2'
							]
						}
					}
				],
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					bodyStyle: '[[eventData.vehicle.bodyStyle]]',
					chromeStyleId: '[[eventData.vehicle.chromeId]]',
					eventSource: 'vehicle',
					eventType: 'impression',
					exteriorColor: '[[eventData.vehicle.exteriorColor]]',
					listingCode: '[[eventData.vehicle.accountId]]',
					listingType: 'standard',
					make: '[[eventData.vehicle.make]]',
					model: '[[eventData.vehicle.model]]',
					pageType: 'vlp',
					price: '[[eventData.vehicle.msrp]]',
					stockNumber: '[[eventData.vehicle.stockNumber]]',
					'type ': 'event',
					vehicleId: '[[eventData.vehicle.uuid]]',
					vehicleType: '[[eventData.vehicle.inventoryType]]',
					vin: '[[eventData.vehicle.vin]]',
					year: '[[eventData.vehicle.year]]'
				},
				trigger: 'vehicleShown'
			},
			{
				logic: [
					{
						mustNotInclude: {
							'DDC.dataLayer.page.pageInfo.params':
								'_disablePixall=true'
						}
					}
				],
				payload: {
					experimental: {
						eventId: '[[eventData.eventId]]'
					},
					eventSource: 'vehicle',
					eventType: 'impression',
					listingType: 'standard',
					pageType: 'vlp',
					type: 'event',
					vin: '[[eventData.vehicle.vin]]'
				},
				trigger: 'vehicleShown'
			}
		],
		specialsEvent: [
			{
				logic: [
					{
						mustInclude: {
							'eventData.widgetName': 'ws-specials',
							'eventData.specialPlacementType': 'listing',
							'eventData.specialType': 'impression'
						}
					}
				],
				payload: '[[fn.getWsSpecialListingImpressionPayloads()]]'
			},
			{
				logic: [
					{
						mustInclude: {
							'eventData.widgetName': 'ws-specials',
							'eventData.specialType': 'click'
						}
					},
					{
						mustInclude: {
							'eventData.widgetName': 'ws-specials',
							'eventData.specialType': 'impression'
						}
					}
				],
				payload: {
					type: 'event',
					eventSource: 'incentive',
					category: 'promotions',
					feature: 'specials_campaign_manager',
					contentId: '[[eventData.specialId]]',
					description: 'promotion',
					eventType: 'view',
					shared: [
						{
							logic: {
								mustInclude: {
									'eventData.specialType': 'click'
								}
							},
							payload: {
								eventType: 'click'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.specialPlacementType':
										'slideshow'
								}
							},
							payload: {
								mediaType: 'slide'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.specialPlacementType': 'banner'
								}
							},
							payload: {
								mediaType: 'banner'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.specialPlacementType': 'listing'
								}
							},
							payload: {
								mediaType: 'coupon'
							}
						}
					]
				}
			},
			{
				logic: [
					{
						mustInclude: {
							'eventData.widgetName': 'ws-inv-listing',
							'eventData.specialType': 'click'
						}
					},
					{
						mustInclude: {
							'eventData.widgetName': 'ws-inv-listing',
							'eventData.specialType': 'impression'
						}
					}
				],
				payload: {
					type: 'event',
					eventSource: 'incentive',
					category: 'promotions',
					feature: 'specials_campaign_manager',
					contentId: '[[eventData.specialId]]',
					description: 'promotion',
					eventType: 'view',
					shared: [
						{
							logic: {
								mustInclude: {
									'eventData.specialType': 'click'
								}
							},
							payload: {
								eventType: 'click'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.specialPlacementType': 'vertical'
								}
							},
							payload: {
								mediaType: 'vertical'
							}
						},
						{
							logic: {
								mustInclude: {
									'eventData.specialPlacementType': 'banner'
								}
							},
							payload: {
								mediaType: 'banner'
							}
						}
					]
				}
			}
		]
	},
	triggerEvents: {
		vehicleShown: {
			payload: {
				event: 'pixall-vehicle-shown',
				eventData: {
					eventId: '[[eventData.eventId]]',
					vin: '[[eventData.vehicle.vin]]'
				}
			},
			sender: 'DDC.pushToGtmDataLayer'
		}
	},
	fireGroups: {
		ajaxPageGroup: {
			minCount: 1
		}
	}
};
